import { Component, OnInit, Input, EventEmitter, Output, ViewChild, ViewContainerRef } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from "@angular/forms";
import { ToolbarItem } from '../../../shared/interfaces/tool-bar-item.interface';
import { ActivatedRoute, Router } from '@angular/router';
import { INotificationService } from '../../../shared/services/inotification.service';
import { FeedbackMessageService } from '../../../shared/services/feedback-message.service';
import { DetailService } from '../../../core/services/detail.service';
import { HttpErrorResponse } from '@angular/common/http';
import { BaseComponent } from '../../../core/models/base-component.model';
import { takeUntil } from 'rxjs/internal/operators/takeUntil';
import { SVGIcon, arrowUpIcon, arrowDownIcon, trashIcon } from '@progress/kendo-svg-icons';
import { Item } from '../../../shared/interfaces/entities/item.interface';
import { AuthenticationService } from '../../../core/services/authentication.serivce';
import { Cart } from '../../../core/interfaces/cart.interface';
import { CartService } from '../../../shared/services/cart.service';
import { SideCartComponent } from '../../../shared/components/side-cart/side-cart.component';
import { MiscellaneousItem } from '../../../shared/interfaces/entities/miscellaneous-item.interface';
import { MiscellaneousItemService } from '../services/miscellaneous-item-service';
import { AuditTypeSelect } from '../../../shared/ui/select-controls/audit-type-select';
import { AuditTypeFilter } from '../../../shared/interfaces/select-filters/audit-type-filter.interface';

@Component({
    selector: 'app-check-out-miscellaneous-item',
    templateUrl: './check-out-miscellaneous-item.component.html',
    styleUrls: ['./check-out-miscellaneous-item.component.css'],
    standalone: false
})

export class CheckOutMiscellaneousItemComponent extends BaseComponent implements OnInit {

  id: string;
  entity: MiscellaneousItem;

  cartItems: any;

  form: FormGroup;

  auditTypeId: AuditTypeSelect;

  formControls: { [k: string]: FormControl } = {};
  submitted: boolean = false;
  toolbarItems: ToolbarItem[] = [];
  cart: Cart[] = [];

  public svgUpArrow: SVGIcon = arrowUpIcon;
  public svgDownArrow: SVGIcon = arrowDownIcon;
  public svgTrash: SVGIcon = trashIcon;
  constructor(private activatedRouter: ActivatedRoute,
    private router: Router,
    private detailService: DetailService<any>,
    private auth: AuthenticationService,
    private fb: FormBuilder,
    private feedback: FeedbackMessageService,
    private notificationService: INotificationService,
    private cartService: CartService,
    private miscItemService: MiscellaneousItemService) {
    super();

    this.activatedRouter.params.subscribe(params => this.id = params['id']);
  }

  ngOnInit(): void {
    var lValue = { id: 5, name: "Notebook" };
    this.auditTypeId = new AuditTypeSelect("auditTypeId", "Type", null);

    var auditTypeFilter: AuditTypeFilter = {
      organizationId: this.auth.getOrganizationId()
    };

    this.auditTypeId.filters = auditTypeFilter;

    this.form = this.fb.group({
      miscellaneousItemId: this.id,
      quantity: [1],
      isLegalHold: true,
      auditTypeId: [null]
    });


    try {
      this.detailService.byId("MiscellaneousItem", this.id)
        .pipe(takeUntil(this.subscription))
        .subscribe({
          next: (data: any) => {
            this.entity = data;
          },
          error: (e: HttpErrorResponse) => {
            var errorMsg: string = e.error;
            if (typeof e.error === "object") {
              errorMsg = e.statusText
            }

            this.notificationService.show({ title: "Error", description: errorMsg.substring(0, 100), type: "error" });
          }
        });
    } catch (err) {
      console.log(err);
    }
  }

  addToCart(): void {

    var auditTypeId = this.auditTypeId.getValue();

    this.form.controls['auditTypeId'].setValue(Number(auditTypeId));
    // Process misc cart data here
    this.cartService.addMiscellaneousItemToCart(this.form.value).subscribe((data => {
      if (data.wasSuccessful) {

        //refresh the cart data
        this.cartService.setRefresh(true);

        //after it's added, open up the cart window
        var wrapper = document.getElementsByClassName('wrapper')[0];
        wrapper.classList.toggle('opened');

        if (wrapper.className.includes("opened")) {
          //add overlay
          document.getElementById('cartOverlay')?.classList.add('k-overlay');
        }
      } else {
        this.notificationService.show({ type: 'error', title: 'Error!', description: data.message });
      }
    }));
  }
}




